<template>
  <div v-click-outside="onClickOutside" class="timer-widget">
    <div
      :class="[
        'timer-widget__timer-wrapper',
        examLayoutV2 && 'timer-widget__timer-wrapper--reverse',
      ]"
    >
      <div
        :class="[
          'timer-widget__timer-details',
          examLayoutV2 && 'timer-widget__timer-details--reverse',
        ]"
      >
        <transition name="slide">
          <div v-if="showTimer" class="timer-widget__title">
            Time remaining {{ currentTime || '' }}
          </div>
        </transition>
        <div class="timer-widget__toggle">
          Show time remaining
          <SwitchCheckbox v-model="showTimer"></SwitchCheckbox>
        </div>
      </div>
      <button
        class="btn btn--secondary timer-widget__alerts-btn btn--default-icon-color"
        @click="toggleModal"
      >
        <ClockIcon />
        Time alerts
      </button>
    </div>
    <transition name="slide">
      <div v-if="showAlerts" class="timer-widget__alerts">
        <div class="timer-widget__alerts-wrapper">
          <XIcon size="13" class="timer-widget__close" @click="toggleModal" />
          <h4 class="timer-widget__subtitle">Alert me when there are</h4>
          <div
            v-for="flag in alertFlags"
            :key="flag.key"
            class="timer-widget__info"
          >
            <span
              :class="`timer-widget__label ${
                flag.value
                  ? 'timer-widget__label--active'
                  : 'timer-widget__label--inactive'
              }`"
              >{{ flag.key }} minutes remaining</span
            >
            <SwitchCheckbox
              v-model="flag.value"
              @change="checkboxChanged"
            ></SwitchCheckbox>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { XIcon } from 'vue-feather-icons'
import SwitchCheckbox from '@/components/forms/elements/SwitchCheckbox.vue'
import ClockIcon from '@/assets/icons/clock_simple_icon.svg'

export default {
  name: 'TimerWidget',
  components: {
    SwitchCheckbox,
    ClockIcon,
    XIcon,
  },
  props: {
    currentTime: {
      type: String,
      required: false,
    },
    examLayoutV2: {
      type: Boolean,
      required: false,
      default() {
        return false
      },
    },
  },
  data: () => {
    return {
      showTimer: true,
      showAlerts: false,
      alertFlags: [
        { key: 5, value: false },
        { key: 10, value: false },
        { key: 30, value: false },
        { key: 45, value: false },
      ],
      somethingChanged: false,
    }
  },
  watch: {
    currentTime(val) {
      this.alertFlags.map(flag => {
        if (flag.value && val === `${flag.key}m0s`) {
          this.$store.dispatch(
            'app/setWarning',
            `There are ${flag.key} minutes remaining on the clock.`
          )
        }
      })
    },
  },
  created() {
    try {
      this.alertFlags.map(flag => {
        flag.value =
          localStorage.getItem(`cert-alert-${flag.key}`) === 'true' || false
      })
    } catch (error) {
      this.$emit('error')
    }
  },
  methods: {
    checkboxChanged() {
      this.somethingChanged = true
      this.alertFlags.map(flag => {
        localStorage.setItem(`cert-alert-${flag.key}`, flag.value)
      })
    },
    toggleModal() {
      this.showAlerts = !this.showAlerts
      if (!this.showAlerts && this.somethingChanged) {
        this.somethingChanged = false
        this.$store.dispatch('app/setSuccess', `Alerts have been saved.`)
      }
    },
    onClickOutside() {
      if (this.showAlerts) {
        this.toggleModal()
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.timer-widget {
  $this: &;
  display: flex;
  justify-content: flex-end;
  &__close {
    position: absolute;
    right: 0;
    top: 0;
    margin: 22px;
    cursor: pointer;
    width: 15px;
    opacity: 0.7;
    &:hover {
      opacity: 1;
    }
    &:active {
      opacity: 0.4;
    }
  }
  &__timer-wrapper {
    display: flex;
    min-width: 190px;
    &--reverse {
      flex-direction: row-reverse;
      gap: 20px;
    }
  }
  &__timer-details {
    float: left;
    margin-right: 15px;
    min-width: 190px;

    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 43px;
    &--reverse {
      flex-direction: column-reverse;
    }
  }

  &__title {
    font-size: 16px;
    line-height: 23px;
  }
  &__toggle {
    line-height: 20px;
    top: 1.5px;
    display: flex;

    .btn__switch {
      margin-left: 10px;
    }
  }

  &__alerts-btn {
    fill: unset !important;
  }

  &__alerts {
    position: absolute;
    margin-top: 58px;
    border-radius: 10px;
    background: var(--glass-mid-gray);
    background-color: var(--darker-gray);
    z-index: 10;
    .btn--secondary {
      margin-top: 20px;
      margin-left: auto;
    }
    &-wrapper {
      padding: 20px;
    }
  }

  &__subtitle {
    margin: 16px 0 10px;
    font-size: rem(18px);
    line-height: 24px;
    font-weight: normal;
  }
  &__time {
    font-size: 22px;
    margin-top: 10px;
  }
  &__info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    color: var(--menu-subcategory);
    margin-bottom: 10px;
    width: 100%;
    flex: 1;

    &:hover {
      color: var(--light-blue-gray);
      .btn__switch {
        -webkit-box-shadow: 0px 4px 40px rgb(255 255 255 / 40%);
        box-shadow: 0px 4px 40px rgb(255 255 255 / 40%);
        border-radius: 34px;
      }
    }
  }
  &__label--active {
    color: var(--white);
  }
  &__label {
    width: 194px;
  }
}
</style>
